import React, { Component } from 'react';
import Navegacao from '../components/Navegacao.js';
import central, { FormatoMoeda, FormatoData } from '../api/Central';
import Resultado from '../api/Resultado.js';
import { Link } from 'react-router-dom'
import Alert from '../components/Alert.js';
import Error from '../components/Error.js';
import StatusBoleto from '../components/StatusBoleto.js';

const Boleto = (props) => {
  var lnk = "/boletos/" + props.boleto.id;
  return (<React.Fragment>
    <tr>
      <td><Link to={lnk}>{FormatoData.format(props.boleto.vencimento)} <StatusBoleto boleto={props.boleto} /></Link></td>
      <td><Link to={lnk}>{props.boleto.descricao}</Link></td>
      <td><Link to={lnk}>{FormatoMoeda.format(props.boleto.valor)}</Link></td>
    </tr>
  </React.Fragment>)
};

class Boletos extends Component {

  constructor(props) {
    super(props);
    this.state = {
      boletos: { rows: [] },
      disabled: false,
      erro: null,
      carregado: true
    }
  }

  redireciona() {
    this.props.history.push("/login");
  }

  carrega() {
    this.setState({ carregando: true });
    central.requestAndCatch(
      "GET",
      "/boletos" + (this.props.conta ? "?conta=" + this.props.conta.idtr : ""),
      null,
      (payload) => {
        var boletos = new Resultado(payload);
        this.setState({ boletos: boletos, carregado: true });
      },
      (msg) => {
        this.setState({ erro: "Erro ao consultar boletos: " + msg });
      },
      () => {
        this.setState({ carregando: false });
      });

  }

  componentDidMount() {
    this.carrega();
  }

  render() {
    var tabela = (<table>
      <thead>
        <tr>
          <th>Vencimento</th>
          <th>Descrição</th>
          <th>Valor</th>
        </tr>
      </thead>
      <tbody>
        {this.state.boletos.rows.map((boleto) => <Boleto key={boleto.id} boleto={boleto} />)}
      </tbody>
    </table>);

    var msgVazio;
    if (this.props.conta) {
      msgVazio = "Não existe nenhum boleto emitido para este serviço.";
    } else {
      msgVazio = "Não existe nenhum boleto avulso.";
    }

    var cabecalho = null;
    if (this.props.conta) {
      cabecalho = (
      <div className="boletos_cabecalho">
        <div className="boletos_cabecalho_titulo">SERVIÇO {this.props.conta.idconta} {!this.props.conta.ativo && " [INATIVO] "}- Vencimento dia {this.props.conta.diavencimento}</div>
        <div className="boletos_cabecalho_subtitulo">
          {this.props.conta.inst_logradouro}
          {this.props.conta.inst_numero ? ", " + this.props.conta.inst_numero : "S/N"}
          {this.props.conta.inst_complemento ? ", " + this.props.conta.inst_complemento : ""}
        </div>
        <div className="boletos_cabecalho_subtitulo">
          {this.props.conta.inst_bairro}
          {this.props.conta.inst_cidade 
          ? (this.props.conta.inst_bairro ? ", " : "") 
          + this.props.conta.inst_cidade + " - " + this.props.conta.inst_estado
          : "" }          
        </div>
      </div>);
    } else if (this.state.boletos.rows.length > 0) {
      cabecalho = (<div className="boletos_cabecalho">Boletos avulsos:</div>);
    }


    var vazio = (<Alert type="info">{msgVazio}</Alert>);

    var erro = (<Error msg={this.state.erro} disabled={this.state.carregando} onButtonClick={this.carrega.bind(this)} buttonLabel="Tentar Novamente" />);

    var loader = (<Alert type="info">Carregando...</Alert>);


    var componente = null;
    if (this.state.carregando) {
      componente = loader;
    } else if (this.state.erro) {
      componente = erro;
    } else if (this.state.boletos.rows.length > 0) {
      componente = tabela;
    } else if (this.props.conta) {
      componente = vazio;
    }

    return (
      ((this.props.conta && this.props.conta.ativo) || this.state.boletos.rows.length > 0) ? <section>
        {cabecalho}
        {componente}
      </section> : <div />

    );
  }
}

class Servico extends Component {
  render() {

    return (
      <React.Fragment>
        <Boletos conta={this.props.conta} />
      </React.Fragment>
    );
  }
}

class Servicos extends Component {

  constructor(props) {
    super(props);
    this.state = {
      carregando: false,
      erro: null,
      contas: { rows: [] }
    }
  }

  carrega() {
    central.listaContas((resultado) => {
      this.setState({ contas: resultado });
    },
      (msgErro) => {
        this.setState({ erro: msgErro });
      },
      () => {
        this.setState({ carregando: false });
      }
    );
  }

  componentDidMount() {
    this.carrega();
  }

  render() {

    return (
      <section className="container">
        <Navegacao link="/" titulo="Meus boletos" />
        <section>
          {this.state.contas.rows.length > 1 && (<Alert type="info">Observação: Você possui {this.state.contas.rows.length} serviços cadastrados. Os boletos abaixo estão separados por serviço.</Alert>)}
          {this.state.contas.rows.map((row) => {
            return (<Servico key={row.idtr} conta={row} />);
          })}
          <Servico />
        </section>
      </section>

    );

  }
}

export default Servicos;